
import seoData from '../seoData.json';

export const getSeoData = (pageUrl) => {
  return seoData.find(item => item.page_url === pageUrl);
};
